import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import _ from 'lodash';

import {
    spaceToUnderscore,
    hasConfirmedSubmission,
    byteToMegabyte,
    isRequestInProgress,
    getMappedKeyEntities
} from "../helpers/helpers";
import { submissionAccessHelper, uploadAccessHelper } from "../helpers/accessHelper";
import FileSubmission from "./FileSubmission";
import Card from "./bootstrap/Card";
import CardBlock from "./bootstrap/CardBlock";
import CardHeader from "./bootstrap/CardHeader";
import CardCheckbox from "./bootstrap/CardCheckbox";
import DueDate from "./DueDate";
import Container from "./bootstrap/Container";
import RunScriptSection from './RunScriptSection';
import * as types from "../constants/actionTypes";
import SubmissionActionLinks from "./SubmissionActionLinks";
import AssignmentFileDownload from "./AssignmentFileDownload";
import { INSTRUCTOR } from "../constants/roles";


class SubmissionForm extends Component {
    constructor(props) {
        super(props);

        this.accessEnabled = this.accessEnabled.bind(this);
        this.instructorAccessAllowed = this.instructorAccessAllowed.bind(this);
        this.confirmMembership = this.confirmMembership.bind(this);
        this.declineMembership = this.declineMembership.bind(this);
        this.handleAssignmentSubmission = this.handleAssignmentSubmission.bind(this);
        this.handleNotDoneChange = this.handleNotDoneChange.bind(this);
        this.hasOptionalFiles = this.hasOptionalFiles.bind(this);
        this.hasRequiredFiles = this.hasRequiredFiles.bind(this);
        this.onDownloadAssignmentFile = this.onDownloadAssignmentFile.bind(this);
        this.onDownloadFile = this.onDownloadFile.bind(this);
        this.onDropAdditionalFiles = this.onDropAdditionalFiles.bind(this);
        this.onDropFixedFilenames = this.onDropFixedFilenames.bind(this);
        this.onRemoveFile = this.onRemoveFile.bind(this);
        this.uploadAllowed = this.uploadAllowed.bind(this);

        this.state = {
            requestInProgress: false,
        };
    }

    componentDidMount() {
        const { auth, assignment, dispatch, memberships, request, submission } = this.props,
            inProgress = this.state.requestInProgress,
            submissionCreateInProgress = isRequestInProgress(
                'submissions.doRequestCreateSubmission',
                request.inProgress
            )
        ;

        if (parseInt(submission.id) === -1 && inProgress === false) {
            //user does not have a submission id
            if (this.uploadAllowed() || this.instructorAccessAllowed()) {
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    ...this.state,
                    requestInProgress: true
                });
                if (!submissionCreateInProgress &&
                    assignment &&
                    assignment.group_submission === false
                ) {
                    //submission does not exist and submission date is open,
                    // send request for new one.
                    dispatch({
                        type: types.SUBMISSION__CREATE__REQUESTED,
                        payload: {
                            submission: {
                                memberships: [
                                    {
                                        user: parseInt(auth.id),
                                        assignment: parseInt(assignment.id),
                                        confirmed: true,
                                        notified: true
                                    }
                                ],
                                user: parseInt(auth.id),
                                assignment: parseInt(assignment.id),
                                not_done: false
                            },
                            assignment: assignment
                        }
                    });
                }
            } else {
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    ...this.state
                });
            }
        } else {
            if (memberships.submission !== submission.id && submission.id !== undefined) {
                dispatch({
                    type: types.SUBMISSION__MEMBERSHIPS__REQUESTED,
                    payload: {
                        submissionId: submission.id,
                    }
                });
            }
        }
    }

    getDropbox() {
        const { dropboxes, params } = this.props;

        return _.last(
            _.filter (dropboxes, dropbox => {
                return dropbox.name === params.dropboxName;
            })
        );
    }

    getMemberships() {
        const { memberships } = this.props;

        return getMappedKeyEntities(memberships);
    }

    renderMembers() {
        const { auth, submission } = this.props,
            memberships = this.getMemberships()
        ;

        return (

            <div className="group-members">
                Group members:&nbsp;
                {
                    memberships && _.map(
                        _.filter(
                            memberships,
                            membership => {
                                return membership.submission.id === submission.id;
                            }
                        ),
                        membership => {
                            return membership.confirmed
                                ?
                                    <span
                                        className="group-member-names"
                                        key={"user_" + membership.user.username}
                                    >
                                        ({membership.user.username})
                                    </span>
                                : null
                            ;
                        }
                    )
                }
                {
                    !hasConfirmedSubmission(auth.id, submission, memberships) ?
                    (
                        <div>
                            <small>
                                {
                                    "You must confirm your group membership " +
                                    "before uploading / submitting files."
                                }
                            </small>
                            <button
                                title="Confirm Group Membership"
                                onClick={this.confirmMembership}
                                className="btn btn-sm btn-warning"
                                type="button"
                            >
                                Confirm &nbsp;
                                <i
                                    className="fa fa-check-circle-o"
                                    aria-hidden="true"
                                />
                            </button>
                            <button
                                title="Decline Group Membership"
                                onClick={this.declineMembership}
                                className="btn btn-sm btn-danger"
                                type="button"
                            >
                                Decline &nbsp;
                                <i
                                    className="fa fa-check-circle-o"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                    )
                    : null
                }
            </div>
        );
    }

    confirmMembership() {

        const { assignment, auth, submission } = this.props,
            memberships = this.getMemberships()
        ;

        let new_group = _.map(
            memberships,
            membership => {
                return parseInt(membership.user.id) === parseInt(auth.id) ?
                    {
                        user : membership.user.id,
                        username : membership.user.username,
                        confirmed : true,
                        notified : true,
                        assignment: assignment.id
                    } :
                    {
                        user : membership.user.id,
                        username : membership.user.username,
                        confirmed : membership.confirmed,
                        notified : membership.notified,
                        assignment: assignment.id
                    }
                ;
            }
        );

        this.props.dispatch({
            type: types.SUBMISSION__CONFIRMATION__REQUESTED,
            payload: {
                submission:{
                    ...submission,
                    memberships: new_group,
                },
            }
        });
    }

    declineMembership() {

        const { assignment, auth, submission } = this.props,
            memberships = this.getMemberships(),
            membership = _.filter(
                memberships,
                membership => {
                    return membership.submission.id === submission.id && membership.user.id === parseInt(auth.id);
                }
            )[0]
        ;

        this.props.dispatch({
            type: types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED,
            payload: {
                assignment: assignment,
                membership: membership
            }
        });
    }

    hasInstructorRole() {
        const { params, roles_self } = this.props,
            dropboxName = params.dropboxName
        ;
        return  _.includes(
            _.flatMap(
                roles_self,
                dropbox_role => {
                    if (dropbox_role.dropbox.name === dropboxName) {
                        return dropbox_role.role;
                    }
                }),
            INSTRUCTOR
        );
    }

    accessEnabled() {
        const { assignment } = this.props;

        return assignment.use_date_control ?
            (
                submissionAccessHelper(
                    assignment.access_open_date,
                    assignment.access_close_date
                )
            ) : (
                //manual
                assignment.access_enabled
            )
        ;
    }

    instructorAccessAllowed() {
        const { auth, assignment, submission } = this.props,
            memberships = this.getMemberships()
        ;

        if (assignment.group_submission && !hasConfirmedSubmission(parseInt(auth.id), submission, memberships)) {
            return false;
        }
        
        return assignment.allow_instructor_access_if_disabled && this.hasInstructorRole();
    }

     uploadAllowed() {
        const { auth, assignment, submission } = this.props,
            memberships = this.getMemberships()
        ;

        if (assignment.group_submission && !hasConfirmedSubmission(parseInt(auth.id), submission, memberships)) {
            return false;
        }

        return assignment.use_date_control ?
            (
                uploadAccessHelper(
                    assignment.submission_open_date,
                    assignment.submission_close_date
                )
            ) : (
                //manual
                assignment.submission_enabled
            )
        ;
    }

    hasRequiredFiles() {
        const { assignment } = this.props,
            { assignment_filenames } = assignment
        ;

        return _.filter(assignment_filenames, ['optional', false]).length > 0;
    }

    hasOptionalFiles() {
        const { assignment } = this.props,
            { assignment_filenames } = assignment
        ;

        return _.filter(assignment_filenames, ['optional', true]).length > 0;
    }

    checkFile(file, fixedName) {
        /* global MAX_SUBMISSION_FILE_UPLOAD_SIZE */
        const { assignment } = this.props,
            regex = /^([A-Za-z0-9\-_ .]){1,255}$/,
            valid_file_name = (file.name).match(regex)
        ;

        if (!valid_file_name){
            this.props.dispatch({
                type: types.ADD_NOTIFICATION,
                payload: {
                    message: "Invalid file name.",
                    level: 'error'
                }
            });
            return false;
        }

        if (fixedName === true) {
            let assignment_filename = _.head(
                _.filter(
                    assignment.assignment_filenames,
                    {
                        name: file.name
                    }
                )
            );

            if (!assignment_filename) {
                //file name not allowed
                this.props.dispatch({
                    type: types.ADD_NOTIFICATION,
                    payload: {
                        message: "File name does not match fixed names.",
                        level: 'error'
                    }
                });
                return false;
            }
        }

        if (file.size > MAX_SUBMISSION_FILE_UPLOAD_SIZE) {
            let message = "File size exceeded limit of: " +
                byteToMegabyte(MAX_SUBMISSION_FILE_UPLOAD_SIZE)
            ;
            this.props.dispatch({
                type: types.ADD_NOTIFICATION,
                payload: {
                    message: message,
                    level: 'error'
                }
            });
            return false;
        }

        if (file.size <= 0) {
            this.props.dispatch({
                type: types.ADD_NOTIFICATION,
                payload: {
                    message: "File must not be empty",
                    level: 'error'
                }
            });
            return false;
        }

        return true;
    }

    onDropFiles(files, fixedName) {
        let { assignment, submission } = this.props;

        if (!this.uploadAllowed() && !this.instructorAccessAllowed()){
            return false;
        }

        _.map(files, (file) => {
            let assignment_filename = _.head(
                _.filter(
                    assignment.assignment_filenames,
                    {
                        name: file.name
                    }
                )
            );

            if (this.checkFile(file, fixedName === true)) {
                let assignment_filename_id = (fixedName === true)
                    ? parseInt(assignment_filename.id)
                    : null
                ;

                this.props.dispatch({
                    type: types.FILE__UPLOAD__REQUESTED,
                    payload: {
                        file: file,
                        submission_id: submission.id,
                        assignment_updated: assignment.updated,
                        assignment_filename_id: assignment_filename_id
                    }
                });
            }
        });
    }

    onDropFixedFilenames(files) {
        this.onDropFiles(files, true);
    }

    onDropAdditionalFiles(files) {
       this.onDropFiles(files, false);
    }

    onDownloadFile(event) {
        event.preventDefault();
        let file_id = event.target.id;
        let file_name = event.target.attributes.getNamedItem('name').value;

        this.props.dispatch({
            type: types.FILE__DOWNLOAD__REQUESTED,
            payload: {
                file_id : parseInt(file_id),
                file_name : file_name
            }
        });
    }

    onDownloadAssignmentFile(event) {
        event.preventDefault();
        let file_id = event.target.id;
        let file_name = event.target.attributes.getNamedItem('name').value;
        let file_size = event.target.attributes.getNamedItem('size').value;

        this.props.dispatch({
            type: types.ASSIGNMENT__FILE__DOWNLOAD__REQUESTED,
            payload: {
                file_id : parseInt(file_id),
                file_name : file_name,
                file_size : parseInt(file_size)
            }
        });
    }

    onRemoveFile(event) {
        event.preventDefault();
        let file_id = event.target.id;

        this.props.dispatch({
            type: types.FILE__DELETE__REQUESTED,
            payload: {
                file_id : parseInt(file_id)
            }
        });
    }

    handleAssignmentSubmission(e) {
        e.preventDefault();

        let { submission } = this.props;

        this.props.dispatch({
            type: types.SUBMISSION__UPDATE__REQUESTED,
            payload: {
                submission
            }
        });
    }

    handleNotDoneChange(event) {
        const target = event.target,
            { assignment, submission } = this.props,
            memberships = this.getMemberships()
        ;


        if (target.type === 'checkbox'){
            let newSubmission = {
                ...submission,
                assignment: assignment.id,
                memberships: _.map(
                    _.filter(
                        memberships,
                        membership => {
                            return membership.submission.id === submission.id;
                        }
                    ),
                    membership => {
                        return {
                            ...membership,
                            user: membership.user.id,
                            assignment: membership.assignment.id
                        };
                    }
                ),
                not_done: !submission.not_done
            };

            this.props.dispatch ({
                type: types.SUBMISSION__UPDATE__NOTDONE__REQUESTED,
                payload: {
                    submission: newSubmission
                },
            });
        }
    }

    render() {
        const { assignment, auth, className, request, roles_self, submission } = this.props,
            dropbox = this.getDropbox(),
            memberships = this.getMemberships()
        ;

        if (!(assignment && dropbox && memberships && roles_self && submission)) {
            return null;
        }

        return (
            <div className="table-responsive">
                <SubmissionActionLinks
                    auth={auth}
                    assignment={assignment}
                    memberships={memberships}
                    roles_self={roles_self}
                    submission={submission}
                />
                <Container
                    title={dropbox.name + ': ' + assignment.name}
                    className={className}
                >
                    <CardBlock>
                        {
                            !this.accessEnabled()
                            ?   <div className="alert alert-warning" role="alert">
                                    <strong>
                                        {
                                            this.hasInstructorRole() && assignment.allow_instructor_access_if_disabled
                                            ? "Assignment: " + assignment.name + " is currently unavailable to students."
                                            : "Assignment: " + assignment.name + " is currently unavailable."
                                        }
                                    </strong>
                                </div>
                            : null
                        }
                        {
                            this.accessEnabled() || assignment.allow_instructor_access_if_disabled && this.hasInstructorRole()
                            ?
                                <div>
                                    {
                                        assignment.group_submission &&
                                        submission.id !== "-1" &&
                                        _.size(
                                            _.filter(
                                                memberships,
                                                membership => {
                                                    return membership.submission.id === submission.id
                                                        && membership.confirmed === false
                                                        && membership.user.id !== parseInt(auth.id)
                                                    ;
                                                }
                                            )
                                        ) >  0
                                        ?
                                            <div className="alert alert-warning" role="alert">
                                                <strong>The following students have not yet confirmed group invitation: </strong>
                                                {
                                                    _.map(
                                                        memberships,
                                                        membership => {
                                                            return membership.submission.id === submission.id
                                                                && membership.confirmed === false
                                                                && membership.user.id !== parseInt(auth.id)
                                                                ?
                                                                    <span
                                                                        key={"user_" + membership.user.username}
                                                                    >
                                                                        ({membership.user.first_name} {membership.user.last_name})
                                                                    </span>
                                                                : null
                                                            ;
                                                        }
                                                    )
                                                }
                                            </div>
                                        : null
                                    }
                                    <DueDate
                                        className="pull-right"
                                        due_date={assignment.due_date}
                                    />
                                    {
                                        !assignment.group_submission
                                        ? 'Individual Submission'
                                        : null
                                    }
                                    {
                                        assignment.group_submission && submission.id === "-1"
                                        ? (
                                            <div className="submission-missing">
                                                <Link to={
                                                    "/" + dropbox.name +
                                                    "/" + spaceToUnderscore(assignment.name) +
                                                    "/group"
                                                }>
                                                    <button
                                                        className="btn btn-md btn-success"
                                                        type="button"
                                                    >
                                                        Create Group&nbsp;
                                                        <i
                                                            className="fa fa-plus-circle"
                                                            aria-hidden="true"
                                                        />
                                                    </button>
                                                </Link>
                                                <div>
                                                    <i>
                                                        <b>
                                                            {
                                                                "You must create a group before " +
                                                                "you can submit the assignment."
                                                            }
                                                        </b>
                                                    </i>
                                                </div>
                                            </div>
                                        ) : (
                                            assignment.group_submission
                                            ? (
                                                this.renderMembers(submission)
                                            ) : null
                                        )
                                    }
                                    <form
                                        className="border-top-0"
                                        onSubmit={this.handleAssignmentSubmission}
                                    >
                                        <Card>
                                            <CardHeader className="bg-primary">Assignment: {assignment.name}</CardHeader>
                                            <Card>
                                                <CardBlock className="no-gutters message">{assignment.description}</CardBlock>
                                            </Card>
                                            {
                                                assignment.use_assignment_files && assignment.assignment_files.length > 0
                                                ?
                                                    <AssignmentFileDownload
                                                        label={'Download Assignment Files'}
                                                        assignment={assignment}
                                                        onDownloadFile={this.onDownloadAssignmentFile}
                                                        disabled={null}
                                                    />
                                                : null
                                            }

                                        </Card>
                                        <Card>
                                            <CardHeader className="bg-primary">Files</CardHeader>
                                            {
                                                this.hasRequiredFiles()
                                                ? (
                                                    <FileSubmission
                                                        onDropFixedFilename={this.onDropFixedFilenames}
                                                        onDropAdditionalFile={this.onDropAdditionalFiles}
                                                        display={'required'}
                                                        label={
                                                            'Required Files (Fixed name files ' +
                                                            'marked as required by Instructor)'
                                                        }
                                                        uploadAllowed={this.uploadAllowed() || this.instructorAccessAllowed()}
                                                        submission={submission}
                                                        assignment={assignment}
                                                        onDownloadFile={this.onDownloadFile}
                                                        onRemoveFile={this.onRemoveFile}
                                                        disabled={
                                                            assignment.group_submission &&
                                                            !hasConfirmedSubmission(auth.id, submission, memberships)
                                                        }
                                                    />
                                                ) : null
                                            }
                                            {
                                                this.hasOptionalFiles()
                                                ? (
                                                    <FileSubmission
                                                        onDropFixedFilename={this.onDropFixedFilenames}
                                                        onDropAdditionalFile={this.onDropAdditionalFiles}
                                                        display={'optional'}
                                                        label={
                                                            'Optional Files (Fixed name files ' +
                                                            'marked as optional by Instructor)'
                                                        }
                                                        uploadAllowed={this.uploadAllowed() || this.instructorAccessAllowed()}
                                                        submission={submission}
                                                        assignment={assignment}
                                                        onDownloadFile={this.onDownloadFile}
                                                        onRemoveFile={this.onRemoveFile}
                                                        disabled={
                                                            assignment.group_submission &&
                                                            !hasConfirmedSubmission(auth.id, submission, memberships)
                                                        }
                                                    />
                                                ) : null
                                            }
                                            {
                                                assignment.allow_arbitrary_uploads
                                                ? (
                                                    <FileSubmission
                                                        onDropFixedFilename={this.onDropFixedFilenames}
                                                        onDropAdditionalFile={this.onDropAdditionalFiles}
                                                        display={'additional'}
                                                        label={
                                                            this.hasOptionalFiles() ||
                                                            this.hasRequiredFiles()
                                                            ? 'Additional Files'
                                                            : 'Files'
                                                        }
                                                        uploadAllowed={this.uploadAllowed() || this.instructorAccessAllowed()}
                                                        submission={submission}
                                                        assignment={assignment}
                                                        onDownloadFile={this.onDownloadFile}
                                                        onRemoveFile={this.onRemoveFile}
                                                        disabled={
                                                            assignment.group_submission &&
                                                            !hasConfirmedSubmission(auth.id, submission, memberships)
                                                        }
                                                    />
                                                ) : null
                                            }
                                        </Card>
                                        {
                                            assignment.allow_not_done
                                            ? (
                                                <CardCheckbox
                                                    side="left"
                                                    id="not_done"
                                                    name="not_done"
                                                    onChange={this.handleNotDoneChange}
                                                    checked={submission.not_done === true}
                                                    disabled={
                                                        submission.id === "-1" ||
                                                        _.includes(request.inProgress, 'submissions.doRequestUpdateNotDoneSubmission') ||
                                                        (
                                                            assignment.group_submission &&
                                                            !hasConfirmedSubmission(auth.id, submission, memberships)
                                                        )
                                                    }
                                                    title={
                                                        assignment.group_submission && submission.id === "-1"
                                                        ? "You must create a group before you can submit the assignment."
                                                        : null
                                                    }
                                                >
                                                    <h6>I am NOT done with my assignment.</h6>
                                                    <label className="help-text">
                                                        {
                                                            "(I will uncheck this box when " +
                                                            "I am done with the assignment.)"
                                                        }
                                                    </label>
                                                </CardCheckbox>
                                            ): null
                                        }
                                        {
                                            assignment.script_enabled
                                            ? (
                                                <RunScriptSection
                                                    uploadAllowed={this.uploadAllowed() || this.instructorAccessAllowed()}
                                                    hasConfirmedSubmission={hasConfirmedSubmission(auth.id, submission, memberships)}
                                                />
                                            ) : null
                                        }
                                        {
                                            !this.uploadAllowed() &&
                                            (   !assignment.group_submission ||
                                                (
                                                    assignment.group_submission &&
                                                    hasConfirmedSubmission(auth.id, submission, memberships)
                                                )
                                            )
                                            ? (
                                                <div
                                                    key="submissions_disabled_instructor"
                                                    className="alert alert-warning"
                                                    role="alert"
                                                >
                                                    <strong>
                                                        {
                                                            this.hasInstructorRole() && assignment.allow_instructor_access_if_disabled
                                                            ? "Student submissions disabled by instructor."
                                                            : "Submissions disabled by instructor."
                                                        }
                                                    </strong>
                                                </div>
                                            ) : null
                                        }
                                    </form>
                                </div>
                            : null
                        }
                    </CardBlock>
                </Container>
            </div>
        );
    }
}

SubmissionForm.propTypes = {
    assignment: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    memberships: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    submission: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { auth, assignment, dropboxes, memberships, submission, request, roles_self } = state;

    return { auth, assignment, dropboxes, memberships, submission, request, roles_self };
}

export default connect(mapStateToProps)(SubmissionForm);



/** WEBPACK FOOTER **
 ** ./src/components/SubmissionForm.js
 **/